import BigNumber from 'bignumber.js';
import { Address } from 'viem';

import { api, cacheTags } from 'modules/api';
import { getPublicClient } from 'modules/api/getPublicClient';
import { handleSafeAppTransaction } from 'modules/api/methods/handleSafeAppTransaction';
import { asAddress } from 'modules/api/utils/asAddress';
import { getWalletClient } from 'modules/api/walletClient';
import { queryFnNotifyWrapper } from 'modules/common/utils/queryFnNotifyWrapper';

import { flashUnstake } from '../methods/flashUnstake';

interface IFlashUnstakeArgs {
  amount: BigNumber;
  poolAddress?: Address;
}

export const { useFlashUnstakeMutation } = api.injectEndpoints({
  endpoints: build => ({
    flashUnstake: build.mutation<Address, IFlashUnstakeArgs>({
      queryFn: queryFnNotifyWrapper<IFlashUnstakeArgs, void, Address>(
        async ({ amount, poolAddress }, { dispatch }) => {
          const walletClient = getWalletClient();
          const publicClient = getPublicClient();

          const txPromise = flashUnstake(walletClient, {
            amount,
            poolAddress,
          });

          const hash = await handleSafeAppTransaction({
            txPromise,
            dispatch,
            publicClient,
            accountAddress: asAddress(walletClient.account?.address),
          });

          return {
            data: hash || '',
          };
        },
      ),
      invalidatesTags: [
        cacheTags.account,
        cacheTags.liquidStaking,
        cacheTags.allowance,
      ],
    }),
  }),
});
